const TechnologySection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Advanced Technology & Quality Standards
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our products are manufactured with cutting-edge technology and rigorous quality control standards
          </p>
        </div>

        {/* Manufacturing Standards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <img 
                src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/23/photo/-.png"
                alt="Factory"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-2">10,000</h3>
            <p className="text-gray-600">Sqm Factory</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <img 
                src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/23/photo/07872b5d43.png"
                alt="ISO Certified"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-2">ISO 13485</h3>
            <p className="text-gray-600">Certified Standard</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <img 
                src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2411/22/photo/centralmanagement.png"
                alt="Production Lines"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-2">5</h3>
            <p className="text-gray-600">Yamaha LED SMT Lines</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <img 
                src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/23/photo/system-config.png"
                alt="Quality Tests"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-2">70+</h3>
            <p className="text-gray-600">Accessory Tests</p>
          </div>
        </div>

        {/* Technology Features */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h3 className="font-serif text-3xl font-medium text-gray-900 mb-6">
              Proprietary LED Technology
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Nogier Frequencies</h4>
                  <p className="text-gray-600">Advanced frequency technology for targeted therapeutic applications</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Multi-Wavelength LEDs</h4>
                  <p className="text-gray-600">Proprietary LED chips: 630nm, 660nm (red light) and 810nm, 850nm (near-infrared)</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Smart Control Systems</h4>
                  <p className="text-gray-600">Centralized management enabling one device to control multiple units</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Power Safety</h4>
                  <p className="text-gray-600">Intelligent circuit design with fault detection for enhanced reliability</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-serif text-3xl font-medium text-gray-900 mb-6">
              Therapeutic Applications
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Pain Relief</h4>
                  <p className="text-gray-600">Effective for chronic pain management and inflammation reduction</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Sports Recovery</h4>
                  <p className="text-gray-600">Accelerates muscle recovery and reduces post-workout soreness</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Skin Rejuvenation</h4>
                  <p className="text-gray-600">Promotes collagen production and improves skin texture</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1">Overall Wellness</h4>
                  <p className="text-gray-600">Supports cellular health, energy levels, and general well-being</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Quality Control */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
          <h3 className="font-serif text-3xl font-medium text-gray-900 mb-8 text-center">
            Rigorous Quality Control
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/20/photo/rigorousQC.jpg"
                  alt="QC Testing"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-medium text-gray-900 mb-2">6-Stage QC Testing</h4>
              <p className="text-sm text-gray-600">Over 70 accessory tests and comprehensive quality checks</p>
            </div>

            <div className="text-center">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/20/photo/componttest.jpg"
                  alt="Component Testing"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-medium text-gray-900 mb-2">Component Testing</h4>
              <p className="text-sm text-gray-600">Automatic testing of LED boards and power supplies with 100% pass rate</p>
            </div>

            <div className="text-center">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/20/photo/machinetest.jpg"
                  alt="Machine Testing"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-medium text-gray-900 mb-2">Machine Testing</h4>
              <p className="text-sm text-gray-600">Circuit inspections, exterior checks, and software evaluations</p>
            </div>

            <div className="text-center">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://ueeshop.ly200-cdn.com/u_file/UPBD/UPBD189/2412/20/photo/redlightbedagingtest.jpg"
                  alt="Aging Test"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-medium text-gray-900 mb-2">48-Hour Aging Test</h4>
              <p className="text-sm text-gray-600">Ensures long-lasting quality and device stability</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;
